<template>
  <div id="projectdiv" style="height: 100%; background: #eff1f6">
    <el-main class="main" style="height: 100%; padding: 0px">
      <router-view></router-view>
    </el-main>
  </div>
</template>

<script>
export default {
  name: "Project",
  watch: {
    $route(newValue) {
      this.$store.dispatch("setActiveName", "index");
    }
  }
};
</script>

<style>
#app {
  height: 100%;
}
.main {
  height: 100%;
  padding: 0;
}
</style>
